import React, { PureComponent, Fragment } from 'react';
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import Help from "../components/Help";

class Success extends PureComponent {
    render(){
        return (
            <Fragment>
                <NavBar pageName="payment" />
                <Help />
                <Footer />
            </Fragment>
        )
    }
}
export default Success;